import { render } from "./건강상담.vue?vue&type=template&id=735329d1"
import script from "./건강상담.vue?vue&type=script&lang=js"
export * from "./건강상담.vue?vue&type=script&lang=js"

import "./건강상담.vue?vue&type=style&index=0&id=735329d1&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__